/**
 * Application configuration for edit mode and presentation mode.
 *
 * - EDIT_MODE = true: All nodes draggable, positions save to localStorage
 * - EDIT_MODE = false: No nodes draggable, positions load from committed JSON file
 */

export const EDIT_MODE = true;
